import { defineMessages } from "react-intl";

const ACCOUNT_REMOVAL = "account-removal";

const accountRemovalMessages = defineMessages({
  removePrivateData: {
    id: `${ACCOUNT_REMOVAL}.remove-private-data`,
    defaultMessage: "Remove private data - 'Right to be Forgotten'",
    description:
      "Header for subsection detailing EBSCO's support for user's 'right to be forgotten'."
  },
  removePrivateDataWithFlag: {
    id: `${ACCOUNT_REMOVAL}.remove-private-data-with-flag`,
    defaultMessage: "Delete my MyEBSCO account and data",
    description:
      "Header for subsection detailing EBSCO's support for user's 'right to be forgotten'."
  },
  removeMyEbscoData: {
    id: `${ACCOUNT_REMOVAL}.remove-my-ebsco-data`,
    defaultMessage: "Remove MyEBSCO account data - 'Right to be Forgotten'",
    description:
      "Header for subsection detailing EBSCO's support for removing MyEBSCO account data"
  },
  rightToBeForgotten: {
    id: `${ACCOUNT_REMOVAL}.right-to-be-forgotten`,
    defaultMessage: "We support your 'Right to be Forgotten'.",
    description:
      "Header for in-page notification detailing how EBSCO enforces user's 'right to be forgotten'."
  },
  rightToBeForgottenWithFlag: {
    id: `${ACCOUNT_REMOVAL}.right-to-be-forgotten-with-flag`,
    defaultMessage: "EBSCO supports your 'Right to be Forgotten'.",
    description:
      "Header for in-page notification detailing how EBSCO enforces user's 'right to be forgotten'."
  },
  explanation: {
    id: `${ACCOUNT_REMOVAL}.explanation`,
    defaultMessage:
      "By removing your personal data from EBSCO, your data and user account will be entirely removed from our system.",
    description:
      "Description for in-page notification detailing how EBSCO enforces user's 'right to be forgotten'."
  },
  explanationWithFlag: {
    id: `${ACCOUNT_REMOVAL}.explanation-with-flag`,
    defaultMessage:
      "Deleting your MyEBSCO account will remove your account and any associated data from our system completely, and cannot be retrieved.",
    description:
      "Description for in-page notification detailing how EBSCO enforces user's 'right to be forgotten'."
  },
  removeMyEbscoDataExplanation: {
    id: `${ACCOUNT_REMOVAL}.remove-my-ebsco-data-explanation`,
    defaultMessage:
      "By removing your MyEBSCO data from EBSCO, your data and user account will be entirely removed from our system.",
    description:
      "Description for in-page notification which describes the impact of removing MyEBSCO data from EBSCO to the user"
  },
  permanentRemovalWarning: {
    id: `${ACCOUNT_REMOVAL}.permanent-removal-warning`,
    defaultMessage:
      "If you proceed, the following will be permanently removed from your EBSCO account:",
    description:
      "Header for subsection to explain what resources will be destroyed if the user opts to remove her data."
  },
  permanentRemovalWarningWithFlag: {
    id: `${ACCOUNT_REMOVAL}.permanent-removal-warning-with-flag`,
    defaultMessage: "This includes:",
    description:
      "Header for subsection to explain what resources will be destroyed if the user opts to remove her data."
  },
  searchHistory: {
    id: `${ACCOUNT_REMOVAL}.search-history`,
    defaultMessage: "Your browsing history, search history and saved searches",
    description:
      "Bullet point text detailing what resources will be destroyed if the user opts to remove her data."
  },
  monitoringHistory: {
    id: `${ACCOUNT_REMOVAL}.monitoring-history`,
    defaultMessage:
      "Any data associated with your account that has been retained for security monitoring or product improvements.",
    description:
      "Bullet point text detailing what resources will be destroyed if the user opts to remove her data."
  },
  personalFolders: {
    id: `${ACCOUNT_REMOVAL}.personal-folders`,
    defaultMessage: "Personal folders and their contents",
    description:
      "Bullet point text detailing what resources will be destroyed if the user opts to remove her data."
  },
  personalFoldersWithFlag: {
    id: `${ACCOUNT_REMOVAL}.personal-folders-with-flag`,
    defaultMessage:
      "Folders and their contents, including all saved items and searches",
    description:
      "Bullet point text detailing what resources will be destroyed if the user opts to remove her data."
  },
  folders: {
    id: `${ACCOUNT_REMOVAL}.folders`,
    defaultMessage: "Folders and their contents",
    description:
      "Bullet point text which describes that the folders and the other contents which related to that corresponding EBSCO account will be destroyed if the user opts to remove the data."
  },
  accountRemoval: {
    id: `${ACCOUNT_REMOVAL}.account-removal`,
    defaultMessage: "Your account will be removed",
    description:
      "Bullet point text detailing what resources will be destroyed if the user opts to remove her data."
  },
  accountRemovalWithFlag: {
    id: `${ACCOUNT_REMOVAL}.account-removal-with-flag`,
    defaultMessage:
      "Your account will be removed, including first name and ID number, if provided to EBSCO at account creation.",
    description:
      "Bullet point text detailing what resources will be destroyed if the user opts to remove her data."
  },
  removeMyData: {
    id: `${ACCOUNT_REMOVAL}.remove-my-data`,
    defaultMessage: "Remove my data",
    description: "Text for button to begin account removal process"
  },
  deleteAccount: {
    id: `${ACCOUNT_REMOVAL}.delete-account`,
    defaultMessage: "Delete my MyEBSCO account",
    description: "Text for button to begin account removal process"
  }
});

export default accountRemovalMessages;
